import { useEffect, useRef, useState } from "react";

import { Box, Flex } from "@/components/layout/flexbox";
import PageTitle from "@/components/pieces/onboarding/PageTitle";

const LOADING_STEPS = {
  initial: "",
  searching: "Finding the perfect coaches for you",
};

export default function FindingAgents({
  intakeForm,
  specialtySlug,
  saveIntakeForm,
}) {
  const mountedRef = useRef(false);
  const [loadingStep, setLoadingStep] = useState("initial");

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    if (loadingStep === "initial") {
      setTimeout(() => {
        setLoadingStep("searching");
      }, 200);
    } else {
      setTimeout(() => {
        if (!mountedRef.current) {
          return;
        }
        // If the intake form doesnt match the requested
        // specialty slug, we need to save the newly requested
        // specialty slug. This edge case can occur when a
        // specialty has no qualification questions.
        if (
          !intakeForm.specialty ||
          intakeForm.specialty.slug !== specialtySlug
        ) {
          saveIntakeForm({});
        } else {
          saveIntakeForm();
        }
      }, 3000);
    }
  }, [loadingStep]);

  return (
    <>
      <Flex justifyContent="center" alignItems="center">
        <Box width={[0.9, 500, 500]} pt={5}>
          <PageTitle
            style={{
              textAlign: "center",
              position: "relative",
            }}
          >
            <Box
              style={{
                position: "absolute",
                left: 0,
                right: 0,
                transition: "all 1000ms ease",
                opacity: loadingStep === "searching" ? 1 : 0,
                transform:
                  loadingStep === "searching"
                    ? "translateY(0%)"
                    : "translateY(100%)",
              }}
            >
              {LOADING_STEPS.searching}
            </Box>
          </PageTitle>
        </Box>
      </Flex>
    </>
  );
}
